import analytics from "@/store/modules/reviews/analytics";
import assessments from "@/store/modules/reviews/assessments";
import automations from "@/store/modules/reviews/automations";
import cycles from "@/store/modules/reviews/cycles";
import participants from "@/store/modules/reviews/participants";
import templates from "@/store/modules/reviews/templates";

export default {
    namespaced: true,
    modules: {
        analytics,
        assessments,
        automations,
        cycles,
        participants,
        templates,
    },
};
